const DOWNLOAD_DELAY_MS = 1500

export default {
  data() {
    return {
      downloadState: 'idle',
      downloadedCount: 0,
      downloadFileCount: 0
    }
  },

  computed: {
    downloadProgress() {
      if (!this.downloadFileCount) {
        return 0
      }

      return Math.round((this.downloadedCount / this.downloadFileCount) * 100)
    }
  },

  created() {
    this._downloadCancelled = false
    this._downloadIframes = []
  },

  beforeDestroy() {
    this._downloadCancelled = true
    this._cleanupIframes()
  },

  methods: {
    async startIframeDownload(files) {
      this.downloadFileCount = files.length
      this.downloadedCount = 0
      this.downloadState = 'downloading'
      this._downloadCancelled = false
      this._downloadIframes = []

      for (const file of files) {
        if (this._downloadCancelled) {
          break
        }

        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = file.temporaryFileUri
        document.body.appendChild(iframe)
        this._downloadIframes.push(iframe)
        this.downloadedCount++
        await new Promise(resolve => setTimeout(resolve, DOWNLOAD_DELAY_MS))
      }

      if (!this._downloadCancelled) {
        this._cleanupIframes()
        this.downloadState = 'idle'
      }
    },

    _cleanupIframes() {
      this._downloadIframes.forEach(iframe => {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe)
        }
      })
      this._downloadIframes = []
    }
  }
}
